import React from "react";
import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AppBar,
  Toolbar,
} from "@mui/material";

/**
 * ダイアログコンポーネント
 * @param {string} title タイトル
 * @param {boolean} open 表示/非表示フラグ
 * @param {Function} onClose ダイアログを閉じた際の処理
 * @param {Node} children 子要素
 * @param {Node} actions ダイアログ下部のボタン
 * @param {string} maxWidth ダイアログ幅
 * @param {boolean} fullScreen 全画面かどうか
 * @class Dialog
 */
export default function Dialog({
  title,
  open,
  onClose,
  children,
  actions,
  maxWidth = "xs",
  fullScreen = false,
  icon,
}) {
  return (
    <MUIDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={fullScreen}
    >
      {fullScreen ? (
        <>
          <AppBar position="static" className="dialog-header" elevation={1}>
            <Toolbar variant="dense">
              <span>{title}</span>
            </Toolbar>
          </AppBar>
        </>
      ) : (
        <>
          {icon}
          <DialogTitle>{title}</DialogTitle>
        </>
      )}
      <DialogContent>{children}</DialogContent>
      <DialogActions className="confirm-actions">{actions}</DialogActions>
    </MUIDialog>
  );
}
